export default {
  // Page text
  title: "User Shared Canvas",
  from: "From",
  userUid: "User UID",
  sharedCanvas: " shared canvas: ",

  // Button
  saveCanvas: "Save Canvas",
};
